import { render, staticRenderFns } from "./ledger.vue?vue&type=template&id=405c1463&"
import script from "./ledger.vue?vue&type=script&lang=js&"
export * from "./ledger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports